<div class="dropdown ori-user">
  <div class="ori-user__button dropdown-toggle" data-toggle="dropdown">
    <div class="ori-user__info-wrapper">
      <div class="ori-user__info">
        <div class="ori-user__name">{{userName}}</div>
        <div class="ori-user__position">{{userPosition}}</div>
      </div>

      <div *ngIf="userAvatar"
           [ngStyle]="{backgroundImage: 'url(' + config.storageUrl + userAvatar + ')'}"
           class="ori-user__avatar">
      </div>
    </div>
  </div>
  <div class="dropdown-menu">
    <a class="dropdown-item" href="#">Профиль</a>
    <a (click)="refreshDb()" class="dropdown-item" style="color: red;">Удалить нарушения</a>
    <div class="dropdown-divider"></div>
    <span (click)="logout()" class="dropdown-item">Выйти</span>
  </div>
</div>
